module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"tomato","showSpinner":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Code by Fernanda Portfolio","short_name":"Code by Fernanda","start_url":"/","background_color":"#36393F","theme_color":"#A3EEF5","display":"standalone","icon":"src/images/icon512.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"c35fe533e7ac99c2a9ed9939080e4801"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/","/bio/*","/skills/*","/projects/*"]},
    }]
